 

export default{
  list: [
    {
      title: '陕北民歌',
      ocName:'陕北民歌·榆林市榆阳区',
      cover:require('@/assets/img/sjcw/sbmg.png'), 
      Key:'folkSong', 
      textColor:'#593014',
      theme:'#D7B298',
      bodyBg:'#F7F0EA',
      path:'subsets',
      bannerUrl:require('@/assets/img/child/folkSong.png'),  
      bannerUrlWx:require('@/assets/img/child/folkSong_wx.png'),  
      intro:[
         {title:'陕北民歌是中国陕西省北部地区的一种传统民间歌唱艺术形式，具有浓郁的民俗文化气息和独特的音乐风格。这些歌曲通常由民间歌手和艺人演唱，歌词内容涉及劳动生活、爱情故事、历史传说等，反映了陕北地区人民的生活习俗和文化传统。陕北民歌的音乐风格独特，采用五声调式，旋律优美、朴素，节奏自由、舒缓，给人以深刻的艺术享受。演唱方式也独具特色，采用民间艺人自创的唱腔和技巧，如真假声交替、滑音、颤音等，使得这些歌曲具有很强的艺术表现力和感染力。 '},
         {title:'陕北民歌具有深刻的思想内涵，通常反映了人民对生活的热爱和对自然的敬畏之情，以及对社会不公和人生苦难的控诉和反思。这些歌曲不仅是一种音乐艺术形式，更是一种思想文化的表达方式，能够引起人们的共鸣和思考。'}    
        ],
      shareList:{
        indexM:'中国民间文化艺术之乡·陕北民歌',
        indexF:'陕西省榆林市榆阳区',
        atlasM:'陕北民歌图集展示',
        atlasF:'中国民间文化艺术之乡·陕北民歌',
        dialectM:'乡话 | 陕北民歌·榆林市榆阳区',
        dialectF:'乡话 | 陕北民歌·榆林市榆阳区',
        characterM:'人物 | 陕北民歌·榆林市榆阳区',
        characterF:'人物 | 陕北民歌·榆林市榆阳区',
        skillM:'技艺 | 陕北民歌·榆林市榆阳区',
        skillF:'技艺 | 陕北民歌·榆林市榆阳区',
        MoocM:'慕课 | 陕北民歌·榆林市榆阳区',
        MoocF:'慕课 | 陕北民歌·榆林市榆阳区',
        newsM:'TA说 | 陕北民歌·榆林市榆阳区',
        newsF:'TA说 | 陕北民歌·榆林市榆阳区', 
        imgUrl:require('@/assets/img/child/folkSong_share.jpg')
      }
    },
    {
      title: '安塞腰鼓',
      ocName:'安塞腰鼓·延安市安塞区',
      cover:require('@/assets/img/sjcw/asyg.png'),
      Key:'waistDrum', 
      path:'subsets',
      textColor:'#AA4141',
      theme:'#DB9E9E',
      bodyBg:'#F8ECEC', 
      bannerUrl:require('@/assets/img/child/waistDrum.png'),  
      bannerUrlWx:require('@/assets/img/child/waistDrum_wx.png'),  
      intro:[
        {title:'安塞腰鼓，流传于陕西省延安市安塞区的传统舞蹈，是国家级非物质文化遗产之一。 '},
        {title:'安塞腰鼓历史悠久，但产生形成的具体时代已难考证。以鼓报警，以鼓助威，以鼓告急，以鼓为乐，这些都是安塞腰鼓的功能。安塞腰鼓分文鼓与武鼓两种，文鼓以扭为主，重扭轻打；武鼓以打为主，重打轻扭。安塞腰鼓是黄河文化的组成部分，是陕北汉子剽悍、虎劲、牛劲的体现，具有民族风格和地域特色。'},
        {title:'2006年5月20日，安塞腰鼓经国务院批准列入第一批国家级非物质文化遗产名录。'},
        {title:''},
      ],
      shareList:{
        indexM:'中国民间文化艺术之乡·安塞腰鼓',
        indexF:'延安市安塞区',
        atlasM:'安塞腰鼓图集展示',
        atlasF:'中国民间文化艺术之乡·安塞腰鼓',
        dialectM:'乡话 | 安塞腰鼓·延安市安塞区',
        dialectF:'乡话 | 安塞腰鼓·延安市安塞区',
        characterM:'人物 | 安塞腰鼓·延安市安塞区',
        characterF:'人物 | 安塞腰鼓·延安市安塞区',
        skillM:'技艺 | 安塞腰鼓·延安市安塞区',
        skillF:'技艺 | 安塞腰鼓·延安市安塞区',
        MoocM:'慕课 | 安塞腰鼓·延安市安塞区',
        MoocF:'慕课 | 安塞腰鼓·延安市安塞区',
        newsM:'TA说 | 安塞腰鼓·延安市安塞区',
        newsF:'TA说 | 安塞腰鼓·延安市安塞区', 
        imgUrl:require('@/assets/img/child/waistDrum_share.jpg')
      }

    },

    {
      title: '皮影',
      ocName:'皮影·渭南市华州区 ', 
      cover:require('@/assets/img/sjcw/py.png'),
      Key:'shadowPlay', 
      path:'subsets',
      textColor:'#533045',
      theme:'#A4909C',
      bodyBg:'#EDE9EB', 
      bannerUrl:require('@/assets/img/child/shadowPlay.png'),  
      bannerUrlWx:require('@/assets/img/child/shadowPlay_wx.png'),  
      intro:[
        {title:' 陕西皮影是陕西省一种非常古老的传统戏曲艺术形式。皮影戏，又称“影戏”或“影子戏”，是一种以兽皮或纸板做成的人物剪影，在灯光照射下用隔亮布进行演戏，是中国民间广为流传的傀儡戏之一。表演时，艺人们在白色幕布后面，一边操纵戏曲人物，一边用陕西特色的碗碗腔或弦板腔唱述故事，同时配以打击乐器和弦乐，有浓厚的秦人气息。尤以陕西华县皮影最为有名，已被列入国家首批非物质文化遗产名录中。'}
      ],
      shareList:{
        indexM:'中国民间文化艺术之乡·皮影',
        indexF:'渭南市华州区',
        atlasM:'皮影图集展示',
        atlasF:'中国民间文化艺术之乡·皮影',
        dialectM:'乡话 | 皮影·渭南市华州区',
        dialectF:'乡话 | 皮影·渭南市华州区',
        characterM:'人物 | 皮影·渭南市华州区',
        characterF:'人物 | 皮影·渭南市华州区',
        skillM:'技艺 | 皮影·渭南市华州区',
        skillF:'技艺 | 皮影·渭南市华州区',
        MoocM:'慕课 | 皮影·渭南市华州区',
        MoocF:'慕课 | 皮影·渭南市华州区',
        newsM:'TA说 | 皮影·渭南市华州区',
        newsF:'TA说 | 皮影·渭南市华州区',
        imgUrl:require('@/assets/img/child/shadowPlay_share.jpg')

      }
    },
    {
      title: '石雕',
      ocName:'石雕·榆林市绥德县四十里铺镇 ', 
      cover:require('@/assets/img/sjcw/sd.png'),
      Key:'stoneCarving', 
      path:'subsets',
      textColor:'#846A27',
      theme:'#C6B17A',
      bodyBg:'#F4EFE4', 
      bannerUrl:require('@/assets/img/child/stoneCarving.png'),  
      bannerUrlWx:require('@/assets/img/child/stoneCarving_wx.png'),  
      intro:[
        {title:'绥德石雕是陕西省榆林市绥德县的地方传统手工技艺。2014年11月11日，列入“第四批国家级非物质文化遗产代表性项目名录”。 '},
        {title:'榆林的石雕之乡在绥德。历经秦汉唐宋，于明清时期，绥德古城内遗留的人文景观、摩崖石刻以及民间广泛流传的石雕艺术品就更是不胜枚举。诸如秦时扶苏监军驻绥时“太子府”遗址，“赏月台”遗址、扶苏屈死于城南二里许的卢家湾，遂有呜咽泉景观和疏属山巅的扶苏墓、扶苏祠等景观；“晋溪洞”“龙洞清流”“天下名州”等摩崖石刻；以及民间老乡家保锁娃娃的炕头石狮狮，与那些深埋墓葬而被挖掘出土的东汉画像石，足以证明石雕艺术源远流长，代代相传。'}
      ],
      shareList:{
        indexM:'中国民间文化艺术之乡·石雕',
        indexF:'榆林市绥德县四十里铺镇',
        atlasM:'石雕图集展示',
        atlasF:'中国民间文化艺术之乡·石雕',
        dialectM:'乡话 | 石雕·榆林市绥德县四十里铺镇',
        dialectF:'乡话 | 石雕·榆林市绥德县四十里铺镇',
        characterM:'人物 | 石雕·榆林市绥德县四十里铺镇',
        characterF:'人物 | 石雕·榆林市绥德县四十里铺镇',
        skillM:'技艺 | 石雕·榆林市绥德县四十里铺镇',
        skillF:'技艺 | 石雕·榆林市绥德县四十里铺镇',
        MoocM:'慕课 | 石雕·榆林市绥德县四十里铺镇',
        MoocF:'慕课 | 石雕·榆林市绥德县四十里铺镇',
        newsM:'TA说 | 石雕·榆林市绥德县四十里铺镇',
        newsF:'TA说 | 石雕·榆林市绥德县四十里铺镇',
        imgUrl:require('@/assets/img/child/stoneCarving_share.jpg')
      }
    },
    {
      title: '陶艺',
      ocName:'陶艺· 铜川市印台区陈炉镇 ', 
      cover:require('@/assets/img/sjcw/ty.png'),
      Key:'pottery', 
      path:'subsets',
      textColor:'#88452F',
      theme:'#D59B88',
      bodyBg:'#F7EBE7', 
      bannerUrl:require('@/assets/img/child/pottery.png'),  
      bannerUrlWx:require('@/assets/img/child/pottery_wx.png'),  
      intro:[
        {title:'陈炉陶瓷业在绵延一千多年的历史长河中，积淀了深厚的陶瓷文化土壤，其陶瓷文化的民间性、历史永久性、可欣赏性和不可替代性，独一无二的民居建筑风格以及富有地域特色的风土人情，涵养了文化旅游的丰富内容和特点。陈炉枕骨瓷窑早在唐代就有“炉火膛里翻火焰”的记载，到了北宋，制瓷业达到鼎盛，以烧造青、白、黑和酱釉瓷而出名，自元代至今，一直是西北地方最重要的瓷业生产基地，其瓷制品的碗、盘、盆、罐、瓶、盒、灯、炉等日常生活用具为主，另有一些陈设器、供器、瓷雕等，釉色有青釉、姜黄釉、黑釉、酱釉、茶末釉、青百双色釉、香黄釉、白釉青花、白地黑花、铁锈花、红绿彩瓷等，陈炉的民俗与陶瓷密切相关，民居、民膳、民艺蕴藏丰厚的陶瓷文化内涵。陈炉民居年代久远。凝结着历代陶工匠人辛勤的汗水和智慧。陶腹、陶穴、罐罐垒墙，依山排布，密如蜂房，被誉为炉山八景之一。瓷片铺路，富有油画效果，极具观赏性，被誉为“脚下的艺术”。'}
     
      ],
      shareList:{
        indexM:'中国民间文化艺术之乡·陶艺',
        indexF:'铜川市印台区陈炉镇',
        atlasM:'陶艺图集展示',
        atlasF:'中国民间文化艺术之乡·陶艺',
        dialectM:'乡话 | 石雕·榆林市绥德县四十里铺镇',
        dialectF:'乡话 | 石雕·榆林市绥德县四十里铺镇',
        characterM:'人物 | 石雕·榆林市绥德县四十里铺镇',
        characterF:'人物 | 石雕·榆林市绥德县四十里铺镇',
        skillM:'技艺 | 石雕·榆林市绥德县四十里铺镇',
        skillF:'技艺 | 石雕·榆林市绥德县四十里铺镇',
        MoocM:'慕课 | 石雕·榆林市绥德县四十里铺镇',
        MoocF:'慕课 | 石雕·榆林市绥德县四十里铺镇',
        newsM:'TA说 | 石雕·榆林市绥德县四十里铺镇',
        newsF:'TA说 | 石雕·榆林市绥德县四十里铺镇',
        imgUrl:require('@/assets/img/child/pottery_share.jpg')

      }
    },
    {
      title: '石刻',
      ocName:'石刻·渭南市富平县宫里镇 ', 
      cover:require('@/assets/img/sjcw/sk.png'),
      Key:'stone', 
      path:'subsets',
      textColor:'#2D5F68',
      theme:'#9ABAC0',
      bodyBg:'#EBF1F2', 
      bannerUrl:require('@/assets/img/child/stone.png'),  
      bannerUrlWx:require('@/assets/img/child/stone_wx.png'),  
      intro:[
        {title:'石雕（富平石刻），陕西省渭南市富平县传统美术，国家级非物质文化遗产名录之一。'},
        {title:'2014年11月11日，石雕（富平石刻）经国务院批准列入第四批国家级非物质遗产名录。'},
        {title:'据富平县志记载，公元534年，北魏《永熙造像》是现存富平石刻工艺有明确年代的最早记录。据此证明，富平石刻有一千五百年多年的历史。景一泉、马建军、杨小兵、何印潮、杜铁旦、赵铁锁、党建、李金平，富平县第三批县级非物质文化遗产项目富平石刻代表性传承人。'},
      ],
      shareList:{
        indexM:'中国民间文化艺术之乡·石刻',
        indexF:'渭南市富平县宫里镇',
        atlasM:'石刻图集展示',
        atlasF:'中国民间文化艺术之乡·石刻',
        dialectM:'乡话 | 石刻·渭南市富平县宫里镇',
        dialectF:'乡话 | 石刻·渭南市富平县宫里镇',
        characterM:'人物 | 石刻·渭南市富平县宫里镇',
        characterF:'人物 | 石刻·渭南市富平县宫里镇',
        skillM:'技艺 | 石刻·渭南市富平县宫里镇',
        skillF:'技艺 | 石刻·渭南市富平县宫里镇',
        MoocM:'慕课 | 石刻·渭南市富平县宫里镇',
        MoocF:'慕课 | 石刻·渭南市富平县宫里镇',
        newsM:'TA说 | 石刻·渭南市富平县宫里镇',
        newsF:'TA说 | 石刻·渭南市富平县宫里镇',
        imgUrl:require('@/assets/img/child/stone_share.jpg')

      }
    },
    {
      title: '龙舞',
      ocName:'龙舞·汉中市汉台区龙江街道 ', 
      cover:require('@/assets/img/sjcw/lw.png'),
      Key:'loongDance', 
      path:'subsets',
      textColor:'#385725',
      theme:'#899E7C',
      bodyBg:'#E7ECE5', 
      bannerUrl:require('@/assets/img/child/loongDance.png'),  
      bannerUrlWx:require('@/assets/img/child/loongDance_wx.png'),  
      intro:[
        {title:'龙舞距今已有一千多年历史，《后汉书·礼仪志》中记载了当时人们举行祈雨等祭祀仪式时儿童、壮年和老人穿着各色彩衣，舞起数丈长青、赤、黄、白、黑等各色大龙。凭借龙形道具，借助人体运动，来完成各种动作和造型。'},
        {title:'“汉中龙江龙舞道具制作技艺”2009年被列入陕西省第二批非物质文化遗产保护项目，龙江龙舞的道具以草龙、板凳龙、握杆龙、彩龙（布龙）四大部分组成。现存的有四类十二项不同特点，不同表演方式的龙制作和造型。'},
        {title:'龙江草龙、女子龙、板凳龙、挝杆龙、五节龙、手龙、手把龙、彩龙等龙舞节目已成为一项地域特色鲜明的民间文化艺术，表演形式深受市民欢迎。'},
      ],
      shareList:{
        indexM:'中国民间文化艺术之乡·龙舞',
        indexF:'龙舞·汉中市汉台区龙江街道',
        atlasM:'龙舞图集展示',
        atlasF:'中国民间文化艺术之乡·龙舞',
        dialectM:'乡话 | 龙舞·汉中市汉台区龙江街道',
        dialectF:'乡话 | 龙舞·汉中市汉台区龙江街道',
        characterM:'人物 | 龙舞·汉中市汉台区龙江街道',
        characterF:'人物 | 龙舞·汉中市汉台区龙江街道',
        skillM:'技艺 | 龙舞·汉中市汉台区龙江街道',
        skillF:'技艺 | 龙舞·汉中市汉台区龙江街道',
        MoocM:'慕课 | 龙舞·汉中市汉台区龙江街道',
        MoocF:'慕课 | 龙舞·汉中市汉台区龙江街道',
        newsM:'TA说 | 龙舞·汉中市汉台区龙江街道',
        newsF:'TA说 | 龙舞·汉中市汉台区龙江街道',
        imgUrl:require('@/assets/img/child/loongDance_share.jpg')

      }
    },
  ]
}



// WEBPACK FOOTER //
// ./src/data/data.js